import { Injectable } from "@angular/core";
import { GridDataService } from "../../base-data-services/grid-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { GridParams, GridPostParams } from "common/models/utility-models/list-utility.model";
import { API_URL } from "common/constants/sm-constants";
import { ApplicantsListingModel, ApplicantsModel, ApplicationGridParams } from "common/models/page-models/applicants/applicant-table/applicant-grid.model";

@Injectable({
    providedIn: 'root',
  })
  export class ApplicantsDataService extends GridDataService<ApplicantsListingModel, ApplicantsModel> {
   
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getStudentApplicationList, http, ss);
    }

    override getGridParams(param): GridPostParams {
        const prevParams = param;
        // console.log(param,prevParams.transferData,'getGridParams')
        const params = new ApplicationGridParams();
        params.statusFlag = prevParams.transferData;
        // console.log(params)
        return params;
      }
    

    createInstance(): ApplicantsListingModel {
        return new ApplicantsListingModel();
    }

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, param);
        data[param].forEach((data) => {
            data.rollNoAndName = '('+data.applicationId+') '+data.orgname;
            // data.AllMarksSum = data.AllMarksSum ? data.AllMarksSum.toFixed(1) : "NA";
            data.Total = parseFloat(data.Total.toFixed(1));
        })
        return data;
    }
    // override getGridParams(params: any): GridPostParams {
    //    return new GridPostParams()
    // }
    override getDeleteUrl(): string {
        return '';
    }
    
  }